<mat-toolbar class="topbar">
  <!-- --------------------------------------------------------------- -->
  <!-- Desktop Menu -->
  @if(showToggle) {
  <button mat-icon-button (click)="toggleCollapsed.emit()" class="d-flex justify-content-center">
    <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
  </button>
  }

  <!-- Mobile Menu -->
  @if(!showToggle) {
  <button mat-icon-button (click)="toggleMobileNav.emit()" class="d-flex justify-content-center">
    <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
  </button>
  }

  <button *ngIf="userInfo.role!='Driver'" mat-icon-button (click)="openDialog()" class="d-flex justify-content-center">
    <mat-icon>cloud_upload</mat-icon>
  </button>

  <div class="d-none d-lg-flex">

  </div>

  <span class="flex-1-auto"></span>



  <!-- --------------------------------------------------------------- -->
  <!-- langugage Dropdown -->
  <!-- --------------------------------------------------------------- -->


  @if (showLang) {
  <div class="tto-lang" role="group" aria-label="Language / Idioma" data-test="header-lang">
    <button type="button" [class.on]="L.lang() === 'en'" (click)="setLang('en')">EN</button>
    <button type="button" [class.on]="L.lang() === 'es'" (click)="setLang('es')">ES</button>
  </div>
  }

  <!-- --------------------------------------------------------------- -->
  <!-- Notification Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <button mat-icon-button [matMenuTriggerFor]="notificationmenu" aria-label="Notifications" class="m-x-5">
    <i-tabler class="d-flex" name="bell" matBadge="{{unreadCount}}" matBadgeColor="primary"></i-tabler>
  </button>
  <mat-menu #notificationmenu="matMenu" class="topbar-dd cardWithShadow">
    <div class="d-flex align-items-center p-x-32 p-y-16">
      <h6 class="f-s-16 f-w-600 m-0 ">Notifications</h6>
      <span class="m-l-auto">
        <span class="bg-primary text-white p-x-8 p-y-4 f-w-500 rounded f-s-12"> {{ unreadCount }} new{{ unreadCount ===
          1 ? '' : ' notifications' }}</span>
      </span>
    </div>
    @for(notification of notifications; track notification.id) {
    <button mat-menu-item class="p-x-32 p-y-16" [ngClass]="{ 'bg-light-primary': !notification.isRead }"
      (click)="markAsRead(notification)">
      <div class="d-flex align-items-center">
        <img [src]="" class="rounded-circle" width="48" />
        <div class="m-l-16">
          <h5 class="f-s-14 f-w-600 m-0">
            {{ notification.title }}
          </h5>
          <span>{{ notification.message | truncateWords:8 }}</span>
        </div>
      </div>
    </button>
    }

    <div class="p-y-12 p-x-32">
      <button mat-stroked-button color="primary" class="w-100">
        See all notifications
      </button>
    </div>
  </mat-menu>


  <!-- --------------------------------------------------------------- -->
  <!-- profile Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <button mat-icon-button [matMenuTriggerFor]="profilemenu" aria-label="Notifications" class="m-l-8">
    <img class="rounded-circle" [src]="avatarImageUrl" width="35" />
  </button>
  <mat-menu #profilemenu="matMenu" class="topbar-dd cardWithShadow">
    <ng-scrollbar class="position-relative" style="height: 647px">
      <div class="p-x-32 p-y-16">
        <h6 class="f-s-16 f-w-600 m-0 ">{{ L.t('User Profile', 'Mi perfil') }}</h6>

        <div class="d-flex align-items-center p-b-24 b-b-1 m-t-16">
          <img class="rounded-circle" [src]="avatarImageUrl" width="95" />

          <div class="m-l-16" *ngIf="userInfo">
            <h6 class="f-s-14 f-w-600 m-0">{{ userInfo.name }} {{ userInfo.lastName }}</h6>
            <span class="f-s-14 d-block m-b-4">{{ userInfo.role | translate }}</span>
            <span class="d-flex align-items-center">
              <i-tabler name="mail" class="icon-15 m-r-4"></i-tabler>
              {{userInfo.email}}
            </span>
          </div>
        </div>
      </div>
      <div class="p-x-32">
        @for(profile of profiledd; track profile.title) {
        <a class="p-y-16 text-decoration-none d-block text-hover-primary" [routerLink]="[profile.link]">
          <div class="d-flex align-items-center">
            <button mat-mini-fab class="text-primary bg-light shadow-none rounded">
              <img [src]="profile.img" width="20" />
            </button>

            <div class="m-l-16">
              <h5 class="f-s-14 f-w-600 m-0 textprimary  hover-text">
                {{ profile.id === 1 ? L.t('My Profile', 'Mi perfil') : profile.id === 2 ? L.t('Notifications', 'Notificaciones') : profile.title }}
              </h5>
              <span class="f-s-14 text-body">{{ profile.id === 1 ? L.t('Account Settings', 'Mis datos e idioma') : profile.id === 2 ? L.t('Notifications', 'Avisos') : profile.subtitle }}</span>
            </div>
          </div>
        </a>
        }

        <!-- upgrade -->

      </div>
      <!-- Company Subscription -->
      @if (
      userInfo &&
      (
      userInfo.role === 'CompanyOwner' ||
      userInfo.role === 'Admin' ||
      userInfo.role === 'SuperAdmin'
      )
      ) {
      <mat-divider></mat-divider>

      <div class="p-x-32 p-y-12">

        <a routerLink="/apps/my-subscription" class="p-y-12 text-decoration-none d-block text-hover-primary">
          <div class="d-flex align-items-center">

            <button mat-mini-fab class="text-primary bg-light shadow-none rounded" type="button" tabindex="-1">
              <i-tabler name="credit-card" class="icon-20"></i-tabler>
            </button>

            <div class="m-l-16">
              <h5 class="f-s-14 f-w-600 m-0 textprimary hover-text">
                My Subscription
              </h5>

              <span class="f-s-14 text-body">
                View your plan and usage
              </span>
            </div>

          </div>
        </a>

      </div>
      }
      <div class="p-y-12 p-x-32">
        <a (click)="logout()" mat-stroked-button color="primary" class="w-100">{{ L.t('Logout', 'Cerrar sesión') }}</a>
      </div>
    </ng-scrollbar>
  </mat-menu>
</mat-toolbar>